import { useState } from "react";
import PopUp from "../PopUp";

// Omaggio su una riga con quantita' > 1 (YELLGO-6114): l'operatore sceglie quante unita' regalare.
// Le unita' in omaggio diventano una riga separata, il resto resta a prezzo pieno.
function GiftPopup({ product, onConfirm, onClose }) {
	const max = parseInt(product.qty) || 1;
	const [qty, setQty] = useState(1);

	return (
		<PopUp
			size="sm"
			options={{
				onClose: onClose,
				title: "Omaggio: " + product.name,
				content: (
					<div className="discount">
						<div className="container">
							<h3>La riga ha {max} unità. Quante ne regali?</h3>
							<div className="plus-minus-large">
								<div>
									<button onClick={() => qty > 1 && setQty(qty - 1)}>-</button>
								</div>
								<input type="text" value={qty} readOnly />
								<button onClick={() => qty < max && setQty(qty + 1)}>+</button>
							</div>
							<div className="discount-type">
								<button onClick={() => onConfirm(max)}>Tutte ({max})</button>
							</div>
						</div>
						<button className="button button-2" onClick={() => onConfirm(qty)}>
							Regala {qty}
						</button>
					</div>
				),
			}}
		/>
	);
}

export default GiftPopup;
